import { useEffect } from "react";
import { Header, Footer } from "@/components/kaje/Chrome";

export const LegalLayout = ({ title, updated, children, testId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="kaje-root bg-[#f8fafc] text-[#0f172a] antialiased min-h-screen" data-testid={testId}>
      <Header />
      <main className="max-w-3xl mx-auto px-6 py-20 kaje-body">
        <span className="text-xs uppercase font-bold tracking-widest text-emerald-700">
          KAJE &mdash; Legal
        </span>
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mt-1 mb-2">
          {title}
        </h1>
        <p className="text-xs text-slate-400 mb-10">Last updated: {updated}</p>
        <div className="space-y-8 text-sm text-slate-600 leading-relaxed">{children}</div>
      </main>
      <Footer />
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="text-lg font-bold text-slate-900 mb-2">{heading}</h2>
    {children}
  </section>
);
